import { useState, useEffect, useRef } from 'react';
import Logo from '../../../img/doc-atento.png'
import { Button } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './style.css';
import { Modal, Box, Tooltip, Typography, LinearProgress } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import CreateIcon from '@mui/icons-material/Create';
import { FillCrown } from '../../Icons';
import { ConteudoPgr } from '../Conteudo/pgr';
import AlertMessage from '../../Alert';
import api from '../../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConteudoPcmso } from '../Conteudo/pcmso';
import { NiveisAcesso } from '../../../constants/niveisAcesso';
import useResponsive from '../../UseResponsive';
import { EyeFill } from 'react-bootstrap-icons';

export function AtentoPGR(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [isDocumentAccessible, setIsDocumentAccessible] = useState(true);
    const [plano, setPlano] = useState(null);
    const [itemPlano, setItemPlano]: any = useState(null);
    const [itemProduto, setItemProduto]: any = useState(null);
    const [quantidade, setQuantidade] = useState<any>();
    const [userId, setUserId] = useState<any>();
    const [userName, setUserName] = useState<any>();
    const [showFirstAccessModal, setShowFirstAccessModal] = useState(false);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [razaoSocial, setRazaoSocial] = useState("");
    const [fdt, setFdt] = useState("");
    const [progressModalOpen, setProgressModalOpen] = useState(false);
    const [progressValue, setProgressValue] = useState(0);
    const [nivelAcesso, setNivelAcesso] = useState(0);
    let [documento, setDocumento] = useState(location.pathname.toLocaleUpperCase().replace('/', ''));
    const [previousDocumento, setPreviousDocumento] = useState(documento);
    const [loading, setLoading] = useState(false);
    const contentRef = useRef(null);
    const [dataInicioVigencia, setDataInicioVigencia] = useState('');
    const currentPath = location.pathname.toLocaleUpperCase().replace('/', '');
    const { width: displayWidth } = useResponsive();
    const isMobile = displayWidth <= 600;
    const [originalWidth] = useState(window.innerWidth);
    const [originalHeight] = useState(window.innerHeight);
    const [hasUploaded, setHasUploaded] = useState(false);
    const [visualize, setVisualize]: any = useState(false);
    const [modalMensagem, setModalMensagem]: any = useState()
    const [showModalVencido, setShowModalVencido]: any = useState()
    const [showModalFuncoes, setShowModalFuncoes]: any = useState(false)
    const [funcoesSemDescricao, setFuncoesSemDescricao] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const response = await api.post(`listar-revisao/${props.idRevisao}/${props.idEmpresa}`);
            if (response && response.data.revisao && response.data.revisao.length > 0) {
                const dataVigencia = formatarDataRevisao(response.data.revisao[0].created_at, 0);
                setDataInicioVigencia(dataVigencia);
            }
        }
        fetchData();
        /*const meses = [
            "JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL", "MAIO", "JUNHO",
            "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"
        ];
        const dataAtual = new Date();
        const mes = meses[dataAtual.getMonth()];
        const ano = dataAtual.getFullYear();

        setDataInicioVigencia(`${mes} DE ${ano}`);*/
    }, []); // O array vazio indica que este efeito roda apenas uma vez, após o primeiro render.

    useEffect(() => {
        api.get('nivel-acesso').then((response: any) => {
            setNivelAcesso(response.data.nivel)
        })
    }, [])


    const data = () => {
        // Lista de meses em maiúsculas
        const meses = ["JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL", "MAIO", "JUNHO", "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"];

        // Supondo que dataInicioVigencia esteja no formato "MÊS DE ANO", por exemplo, "SETEMBRO DE 2023"
        // Removendo "DE" e separando mês e ano
        const partes = dataInicioVigencia.replace(/\s+DE\s+/g, ' ').split(' ');
        const mesString = partes[0];
        const anoString = partes[1];

        // Encontrando o índice do mês
        const mesIndex = meses.indexOf(mesString.toUpperCase());
        const ano = parseInt(anoString);

        // Criando um objeto Date com o mês e ano de início de vigência
        const dataVigencia = new Date(ano, mesIndex, 1);

        // Adicionando 12 meses para a revisão anual obrigatória
        dataVigencia.setMonth(dataVigencia.getMonth() + 12);

        // Formatando a nova data
        const mesFormatado = meses[dataVigencia.getMonth()];
        const anoFormatado = dataVigencia.getFullYear();

        // Resultado final
        const resultado = `${mesFormatado} DE ${anoFormatado}`;
        return resultado;
    }

    function formatarDataRevisao(dataOriginal: string, anosParaAdicionar: number) {
        let data = new Date(dataOriginal);
        data.setFullYear(data.getFullYear() + anosParaAdicionar);
        return data.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' }).toUpperCase();
    }

    const genPDF = async () => {
        setProgressModalOpen(true)
        simulateProgress()
        const content: any = contentRef.current;
        if (!content) {
            console.error('Content ref is null. Make sure the component has rendered.');
            return;
        }

        // Inicializa jsPDF aqui dentro para garantir que tudo está montado
        const doc: any = new jsPDF();

        const pages = content.querySelectorAll('.page');

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            const isLandscape = page.classList.contains('landscape');

            // Configura a orientação da página com base na classe .landscape
            const orientation = isLandscape ? 'landscape' : 'portrait';

            if (i > 0) {
                doc.addPage([297, 210], orientation);
            }

            // Usa html2canvas para capturar o conteúdo da página
            await html2canvas(page, { scale: 1 }).then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg');
                doc.addImage(imgData, 'JPEG', 0, 0,);
            });
        }

        // Salva o documento após adicionar todas as páginas
        doc.save('documento.pdf');

        setProgressModalOpen(false)

    };


    useEffect(() => {
        const buscarDadosEmpresa = async () => {
            try {
                const response = await api.get(`/empresas/listar/${props.idEmpresa}`);
                const empresa = response.data;

                setRazaoSocial(empresa.nome);

            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosEmpresa();
    }, [props.idEmpresa]);

    useEffect(() => {
        const buscarDadosFdt = async () => {
            try {
                const response = await api.post(`listar-fdt/${props.idFdt}`, { id_empresa: props.idEmpresa });
                const fdt = response.data.fdt[0];

                setFdt(fdt.nome);
                setProgressValue(0);

            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosFdt();
    }, [props.idFdt]);


    const style = {
        position: 'absolute',
        top: '80%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 1123,
        height: 1123,
    };

    const [showAlert, setShowAlert] = useState(false);

    const handleClose = () => setOpen(false);

    const handleCloseModals = () => {
        setOpen(false);
        setConfirmModal(false);
    }

    const generatePDF = async () => {
        setConfirmModal(false);
        simulateProgress();

        const content: any = contentRef.current;
        if (!content) {
            console.error('Content ref is null. Make sure the component has rendered.');
            return;
        }

        const doc: any = new jsPDF();

        const pages = content.querySelectorAll('.page');

        if (pages) {
            pages.forEach((element: any) => {
                element.style.backgroundImage = 'none';
            });
        }

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            const isLandscape = page.classList.contains('landscape');
            const orientation = isLandscape ? 'landscape' : 'portrait';

            if (i > 0) {
                doc.addPage([297, 210], orientation);
            }

            await html2canvas(page, { scale: 1 }).then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg');
                doc.addImage(imgData, 'JPEG', 0, 0);
            });
        }

        const arrayBuffer = doc.output('arraybuffer');
        const fileName = `document${props.idEmpresa}_${props.idFdt}_${props.idRevisao}_${documento}.pdf`;
        await uploadPDF(arrayBuffer, fileName);
    };

    const simulateProgress = () => {
        const interval = setInterval(() => {
            setProgressValue((prevValue) => {
                if (prevValue < 95) {
                    return prevValue + 1;
                } else {
                    clearInterval(interval);
                    return prevValue;
                }
            });
        }, 1200);
    };


    const uploadPDF = async (arrayBuffer: any, fileName: any) => {
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const formData = new FormData();
        formData.append('file', blob, fileName);
        formData.append('fileName', fileName);
        formData.append('responsibleId', props.responsavel);
        formData.append('idEmpresa', props.idEmpresa);
        formData.append('idFdt', props.idFdt);
        formData.append('idRevisao', props.idRevisao);
        formData.append('routeName', documento);

        setProgressModalOpen(true);

        try {
            const response = await api.post('upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

            if (response.status === 200) {
                setAlert({ message: 'Documento enviado para assinatura!', variant: 'success', show: true });
                setShowAccessModal(false);
                setProgressModalOpen(false);
                setConfirmModal(false);
                setOpen(false);

                if (!hasUploaded) {
                    setHasUploaded(true);
                    setDocumento((prevDocumento) => (prevDocumento === "PGR" ? "PCMSO" : "PGR"));
                }
                if (hasUploaded) {
                    await delay(800);
                    navigate('/documentos')
                }
            }
        } catch (error) {
            console.error("Error uploading PDF:", error);
            setProgressModalOpen(false);
        }
    };

    useEffect(() => {
        const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

        const handleDocumentChange = async () => {
            await delay(50);
            handleOpen();
            await delay(6000);
            handleSearchFunctionAndGeneratePDF();
        };

        if (documento !== previousDocumento) {
            handleDocumentChange();
            setPreviousDocumento(documento);
        }
    }, [documento, previousDocumento]);

    useEffect(() => {
        api.get('dados-usuario').then((response: any) => {
            setUserId(response.data.id)
            setUserName(response.data.name)
        })
    }, [])


    const handleEnviarEmissao = async () => {
        try {

            const productResponse = await api.get(`listar-produto-user/${props.idEmpresa}/${props.idFdt}`);
            const productData = productResponse.data;

            await api.post('atualizar-adicional', productData);

            await api.post('enviar-emissao', props.idRevisao);

            await api.post('bloquear-fdt', {
                idFdt: props.idFdt,
                currentPath: documento
            });

        } catch (error) {
            console.log(error);
        }
    }


    const handleSearchFunctionAndGeneratePDF = () => {

        if (props?.responsavel) {
            setVisualize(false);
            setProgressValue(0);
            setProgressModalOpen(true);
            handleEnviarEmissao();
            generatePDF();

        } else {
            setAlert({ show: true, message: 'Selecione um responsável!', variant: 'danger' });
        }
    }



    const handleOpen = () => {
        setLoading(true);

        if (!props.responsavel) {
            setShowAlert(true);
            setLoading(false);
            return;
        }
        setOpen(true);
        if (!isDocumentAccessible) {
            setShowAccessModal(true);
        }

        setTimeout(() => {
            let alturaMaximaDaPag: any = 775;
            let numeroDaPagina = 3;

            function dividirEClonarElementoGrande(elemento: HTMLElement, paginaAtual: HTMLElement, alturaAcumuladaRef: { current: number }, alturaMaximaDaPag: number, isLandscape: boolean) {
                let grupoFilhos: HTMLElement[] = [];
                Array.from(elemento.children as HTMLCollectionOf<HTMLElement>).forEach((filho: any) => {
                    if (!filho.hasChildNodes() && filho.textContent.trim() === '') {
                        return;
                    }

                    const alturaFilho = calcularAlturaTotalElemento(filho);

                    if (alturaAcumuladaRef.current + alturaFilho > alturaMaximaDaPag) {
                        // Usa clonarGrupoFilhos para adicionar o grupo atual de filhos ao clone pai na página atual.
                        if (grupoFilhos.length > 0) {
                            clonarGrupoFilhos(elemento, grupoFilhos, paginaAtual);
                            grupoFilhos = []; // Reseta o grupo de filhos após clonar
                        }

                        paginaAtual = criarNovaPagina(isLandscape);
                        alturaAcumuladaRef.current = 0;
                    }

                    grupoFilhos.push(filho); // Adiciona o filho ao grupo atual
                    alturaAcumuladaRef.current += alturaFilho;
                });

                // Clona qualquer grupo de filhos restante
                if (grupoFilhos.length > 0) {
                    clonarGrupoFilhos(elemento, grupoFilhos, paginaAtual);
                }
            }

            // Função ajustada para utilizar diretamente dentro de dividirEClonarElementoGrande.
            function clonarGrupoFilhos(elementoPai: HTMLElement, grupoFilhos: HTMLElement[], paginaAtual: HTMLElement) {
                const clonePai = elementoPai.cloneNode(false) as HTMLElement;
                grupoFilhos.forEach((filho) => clonePai.appendChild(filho.cloneNode(true)));
                paginaAtual.querySelector('.page-content')?.appendChild(clonePai);
            }


            const elementos = document.querySelectorAll('.texto > div');
            let paginaAtual: any = criarNovaPagina();
            let alturaAcumuladaRef = { current: 0 };

            elementos.forEach((elemento: any) => {
                const alturaElemento: any = calcularAlturaTotalElemento(elemento);

                const isLandscape = elemento.getAttribute('data-landscape') === 'true';
                // Verifica se é necessário mudar a orientação da página e/ou começar uma nova página
                if (isLandscape || elemento.getAttribute('data-new-page') === 'true' || alturaAcumuladaRef.current + alturaElemento > alturaMaximaDaPag) {
                    paginaAtual = criarNovaPagina(isLandscape);
                    alturaAcumuladaRef.current = 0;
                }

                // Verifica se o elemento atual deve começar em uma nova página
                if (elemento.getAttribute('data-new-page') === 'true') {
                    paginaAtual = criarNovaPagina(isLandscape);
                    alturaAcumuladaRef.current = 0;
                }

                // Verifica se o elemento deve ser exibido em paisagem



                if (alturaAcumuladaRef.current + alturaElemento > alturaMaximaDaPag) {

                    dividirEClonarElementoGrande(elemento, paginaAtual, alturaAcumuladaRef, alturaMaximaDaPag, isLandscape);

                    paginaAtual = criarNovaPagina(isLandscape);

                    alturaAcumuladaRef.current = 0;
                } else {
                    const clone = elemento.cloneNode(true);
                    paginaAtual.querySelector('.page-content').appendChild(clone);
                    alturaAcumuladaRef.current += alturaElemento;
                }

                // Se o próximo elemento deve começar em uma nova página, resetar isLandscape
                if (alturaAcumuladaRef.current >= alturaMaximaDaPag) {
                    paginaAtual = criarNovaPagina(isLandscape);
                    alturaAcumuladaRef.current = 0;
                }
            });

            removerElementosOriginais()
            removerPaginasEmBranco()

            // Função para verificar e ajustar a altura máxima da página baseada na presença de tabelas
            // Esta função agora precisa ser chamada após adicionar o conteúdo à página

            function criarNovaPagina(isLandscape = false, isSummary = false) {
                const contentPdf: any = document.getElementById('content-pdf');
                const novaPagina = document.createElement('div');

                novaPagina.classList.add('page');


                if (isSummary) {
                    novaPagina.classList.add('summary');
                }
                if (isLandscape) {
                    novaPagina.classList.add('landscape');
                    alturaMaximaDaPag = 700; // Altura para paisagem
                } else {
                    alturaMaximaDaPag = 830; // Altura para retrato
                }

                // Criar e adicionar cabeçalho
                const cabecalho = document.createElement('div');
                cabecalho.classList.add('page-header');
                cabecalho.innerHTML = `
                    <div  class="logo-header">
                    <img src="${Logo}">
                    </div>
                    <p>ATENTO MEDICINA DO TRABALHO LTDA</p>
                    <p>11.509.053/0001-59</p>
                    <p>41 3642-6495</p>
                    <p>Rua Heitor Alves Guimarães, 495</p>
                    <p>ARAUCÁRIA - PARANÁ</p>
                `;

                novaPagina.appendChild(cabecalho);

                // Criar e adicionar conteúdo principal
                const novoConteudo = document.createElement('div');
                novoConteudo.classList.add('page-content');
                novaPagina.appendChild(novoConteudo);

                // Criar e adicionar rodapé
                const rodape = document.createElement('div');
                rodape.classList.add('page-footer');
                rodape.innerHTML = `
                    <p><b>ATENTO MEDICINA DO TRABALHO LTDA</b></p>
                    <p><b>CNPJ</b> 11.509.053/0001-59</p>
                    <p>41 3642-6495 - Rua Heitor Alves Guimarães, 495 - ARAUCÁRIA - PARANÁ</p>
                    <p>E-mail: comercial@medicoatento.com.br</p>
                `;

                novaPagina.appendChild(rodape);

                // Criar e adicionar numeração de página
                const numeracaoPagina = document.createElement('div');
                numeracaoPagina.classList.add('page-number');
                numeracaoPagina.innerHTML = `${numeroDaPagina}`;

                novaPagina.appendChild(numeracaoPagina);


                contentPdf.appendChild(novaPagina);

                numeroDaPagina++; // Incrementa o número da página para a próxima

                return novaPagina;
            }


            function calcularAlturaTotalElemento(elemento: HTMLElement) {
                // const estilo = window.getComputedStyle(elemento);
                // return elemento.offsetHeight + parseInt(estilo.marginTop, 10) + parseInt(estilo.marginBottom, 10);
                return elemento.offsetHeight;
            }

            function removerPaginasEmBranco() {
                const paginas = document.querySelectorAll('.page');
                paginas.forEach(pagina => {
                    // Verifica se a página contém mais do que apenas o cabeçalho e o rodapé
                    const conteudoPagina = pagina.querySelector('.page-content');
                    // Considera uma página como em branco se o conteúdo principal estiver vazio (sem filhos)
                    if (!conteudoPagina || conteudoPagina.children.length === 0) {
                        pagina.remove(); // Remove a página em branco
                    }
                });
            }
            function removerElementosOriginais() {
                // Supondo que os elementos originais estão dentro de um container com a classe 'texto'
                const containerOriginal = document.querySelector('.texto');
                if (containerOriginal) {
                    // Remove o container inteiro
                    containerOriginal.remove();
                }
                // Ou, se precisar remover apenas os elementos clonados individualmente, use algo como:
                // document.querySelectorAll('.texto > div').forEach(elemento => elemento.remove());
            }
            function adicionarPaginaDeSumario() {
                let paginaSumario = criarNovaPagina(false, true); // Cria a primeira página para o sumário
                let conteudoSumario: any = paginaSumario.querySelector('.page-content');
                let alturaAcumulada = 0;
                const alturaMaximaDaPag = 675; // Altura máxima para retrato, ajuste conforme necessário

                const elementosComSumario = document.querySelectorAll('[data-sum]');
                elementosComSumario.forEach(elemento => {
                    const titulo = elemento.textContent; // Texto do título para o sumário
                    const numeroDaPagina = encontrarNumeroDaPagina(elemento); // Função para encontrar o número da página

                    const rowSum = document.createElement('div');
                    rowSum.style.display = 'flex';
                    rowSum.style.justifyContent = 'space-between';
                    rowSum.style.alignItems = 'center';
                    rowSum.style.margin = '5px 0';
                    rowSum.className = 'rowSum';

                    const titleSum = document.createElement('span');
                    titleSum.className = 'titleSum';
                    titleSum.style.width = '100%';
                    titleSum.style.display = 'flex';
                    titleSum.style.justifyContent = 'space-between';
                    titleSum.textContent = titulo;

                    const numSum = document.createElement('span');
                    numSum.className = 'numSum';
                    numSum.style.display = 'flex';
                    numSum.style.alignItems = 'end';
                    numSum.textContent = numeroDaPagina;

                    rowSum.appendChild(titleSum);

                    const dottedSpan = document.createElement('span');
                    dottedSpan.className = 'dottedSum';
                    // Inserir lógica para ajustar os pontos aqui, se necessário
                    titleSum.appendChild(dottedSpan);
                    titleSum.appendChild(numSum);

                    // Adiciona o rowSum ao conteúdo do sumário e verifica a altura
                    conteudoSumario.appendChild(rowSum);
                    alturaAcumulada += rowSum.offsetHeight;

                    // Verifica se a altura acumulada ultrapassou a altura máxima da página
                    if (alturaAcumulada > alturaMaximaDaPag) {
                        // Cria uma nova página para o sumário
                        paginaSumario = criarNovaPagina(false, true);
                        conteudoSumario = paginaSumario.querySelector('.page-content');
                        // Reseta a altura acumulada e adiciona o item de sumário atual à nova página
                        alturaAcumulada = rowSum.offsetHeight;
                    }
                });
            }





            function encontrarNumeroDaPagina(elemento: any) {
                let atual = elemento;
                while (atual && !atual.classList.contains('page')) {
                    atual = atual.parentNode;
                }
                if (atual) {
                    const numeroDaPagina = atual.querySelector('.page-number');
                    return numeroDaPagina ? numeroDaPagina.textContent : '?';
                }
                return '?';
            }
            function moverPaginasSumario() {
                const contentPdf = document.getElementById('content-pdf');
                const paginasSumario = Array.from(document.querySelectorAll('.summary'));
                let posicaoInsercao = 1; // A posição de inserção começa em 1 para mover para a posição "2" (índices base 0)

                // Verifica se o contêiner e as páginas de sumário existem
                if (contentPdf && paginasSumario.length > 0) {
                    // Move cada página de sumário para a posição correta
                    paginasSumario.forEach((pagina, index) => {
                        // Calcula a posição atual considerando que as páginas estão sendo movidas uma a uma
                        let posicaoAtual = posicaoInsercao + index;
                        if (contentPdf.children[posicaoAtual]) {
                            contentPdf.insertBefore(pagina, contentPdf.children[posicaoAtual]);
                        } else {
                            // Se a posição calculada exceder o número de filhos, simplesmente anexa ao final
                            contentPdf.appendChild(pagina);
                        }
                    });
                }
            }

            // Após a geração do PDF e a adição das páginas de sumário, chame moverPaginasSumario

            // Após a geração do PDF, chame adicionarPaginaDeSumario
            setTimeout(() => {
                adicionarPaginaDeSumario();
                setTimeout(() => {
                    moverPaginasSumario();

                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);

                }, 1000); // Ajuste o timeout conforme necessário para garantir que seja chamado após a adição das páginas de sumário

            }, 1000); // Ajuste o timeout conforme necessário


        }, 1000);

    };

    const liberarRevisao = async () => {
        await api.post('liberar-revisao', {
            id_emissao: props.selectedEmissaoId,
            id_revisao: props.idRevisao,
            id_empresa: props.idEmpresa,
            id_fdt: props.idFdt,
        });
    }

    const checkIfRevisionExpired = async (idEmpresa: any, idRevisao: any): Promise<boolean> => {
        try {
            const response = await api.post('verificar-status-revisao', {
                id_empresa: idEmpresa,
                id_fdt: props.idFdt,
                id_revisao: idRevisao
            });

            const revisaoData = response.data;

            if (revisaoData.length > 0) {
                const revisao = revisaoData[0];

                if (revisao.expires_at) {
                    const dataAtual = new Date();
                    const dataExpiracao = new Date(revisao.expires_at);

                    return dataAtual > dataExpiracao;
                }
            }

            return false;
        } catch (error) {
            console.error('Erro ao verificar expiração da revisão:', error);
            return false;
        }
    };

    const handleSearchFunctionQuantity = async () => {
        if (nivelAcesso !== NiveisAcesso.ADMIN) {
            const productResponse = await api.get(`listar-produto-user/${props.idEmpresa}/${props.idFdt}`);
            const productData = productResponse.data;
            setPlano(productData);

            const itemResponse = await api.get(`listar-item-produto-user/${props.idEmpresa}/${props.idFdt}`);
            setItemPlano(itemResponse.data);

            if (!productData.length || productData[0].id_produto === 0 || productData[0].id_produto == null) {
                setShowFirstAccessModal(true);
                return;
            }

            if (itemPlano) {
                const hasPGRItem = itemPlano.some((item: { id_item: number; }) => item.id_item === 1);
                const hasPCMSOItem = itemPlano.some((item: { id_item: number; }) => item.id_item === 2);

                if ((documento === 'PGR' && !hasPGRItem) || (documento === 'PCMSO' && !hasPCMSOItem)) {
                    setShowPlanModal(true);
                    return;
                } else {
                    const functionResponse = await api.get(`listar-quantidade-funcoes/${productData[productData.length - 1].id_produto}`);
                    const functionData = functionResponse.data;
                    const quantidade = functionData[0]?.quantidade || 0;
                    setQuantidade(quantidade);

                    if (quantidade !== 0 && quantidade != null) {
                        if (props.funcoes.length <= quantidade) {
                            const isExpired = await checkIfRevisionExpired(props.idEmpresa, props.idRevisao);
                            if (isExpired) {
                                setModalMensagem('Seu plano ou revisão está expirado. Por favor, adquira uma nova revisão.');
                                setShowModalVencido(true);
                                return;
                            }
                            handleOpen();
                            await generatePDF();
                            await new Promise(() => setTimeout(async () => {
                                setConfirmModal(true);
                            }, 4000));
                        } else {
                            setShowAccessModal(true);
                        }
                    } else {
                        setShowAccessModal(true);
                    }
                }
            }
        } else {
            const hasEmptyDescription = props.funcoes.filter((func: any) => !func.descricao || func.descricao.trim() === '');
            console.log(hasEmptyDescription)
            if (hasEmptyDescription.length > 0) {
                setFuncoesSemDescricao(hasEmptyDescription)
                setShowModalFuncoes(true)
                return;
            }

            handleOpen();
            await generatePDF();
            await new Promise(() => setTimeout(async () => {
                setConfirmModal(true);
            }, 4000));
        }
    };


    const handleCloseAccessModal = () => {
        setShowAccessModal(false);
    };

    const handleCloseFirstAccessModal = () => {
        setShowFirstAccessModal(false);
    };

    const handleClosePlanModal = () => {
        setShowPlanModal(false);
    };

    const handleCloseFunctionModal = () => {
        setShowModalFuncoes(false)
    }

    const liberarDocumento = async () => {
        await handleSearchFunctionQuantity();
        await liberarRevisao();
    };

    const visualizeDocument = async () => {
        try {
            if (nivelAcesso !== NiveisAcesso.ADMIN) {
                const itemResponse = await api.get(`listar-item-produto-user/${props.idEmpresa}/${props.idFdt}`);

                if (itemResponse.data) {
                    const hasPGRItem = itemResponse.data.some((item: { id_item: number; }) => item.id_item === 1);
                    const hasPCMSOItem = itemResponse.data.some((item: { id_item: number; }) => item.id_item === 2);

                    if ((documento === 'PGR' && !hasPGRItem) || (documento === 'PCMSO' && !hasPCMSOItem)) {
                        setShowPlanModal(true);
                        return;
                    } else {
                        setVisualize(true);
                        handleOpen();
                        await generatePDF();
                    }
                } else {
                    setShowPlanModal(true);
                    return;
                }
            } else {
                setVisualize(true);
                handleOpen();
                await generatePDF();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const downloadMobile = async () => {
        setLoading(true);
        await liberarDocumento();
        await new Promise(() => setTimeout(async () => {
            if (isMobile) {
                window.innerWidth = 1080;
                window.innerHeight = 1920;
            }
            await genPDF();
            if (isMobile) {
                window.innerWidth = originalWidth;
                window.innerHeight = originalHeight;
            }
            handleClose();
            setAlert({ show: true, message: 'O documento foi baixado em seu dispositivo!', variant: 'success' });
        }, 4000));
        setLoading(false);
    }

    return (
        <>
            <AlertMessage
                message="Responsável técnico não definido. Por favor, defina um responsável para gerar o documento."
                variant="danger"
                show={showAlert}
                onClose={() => setShowAlert(false)}
            />
            {isMobile ? (
                <Button className='btn-main mt-4' onClick={downloadMobile}>
                    <DownloadIcon />
                    Download
                </Button>
            ) : (
                <div id='pgrStep5' className='document-buttons'>
                    <Button className='pgr-finalize-button mt-4' onClick={visualizeDocument}>
                        <EyeFill style={{ marginRight: '10px' }} />
                        Visualizar Documento
                    </Button>
                    {((props.externoPgr != 1 && props.enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                        <Button className='pgr-finalize-button mt-4' onClick={liberarDocumento}>
                            <PictureAsPdfIcon style={{ marginRight: '10px' }} />
                            Finalizar Documento
                        </Button>
                    )}
                </div>
            )}
            <div className={`loading ${loading === true ? 'opacity1' : 'opacity0'}`} >
                <div className='lds-ring'><div></div><div></div><div></div><div></div></div>
            </div >

            <Modal
                id="modal-pdf"
                open={open}
                onClose={() => {
                    if (visualize == true) {
                        handleClose();
                    }
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflow: 'auto' }}
                className={`${isDocumentAccessible ? '' : 'planoModal'}`}
                disableEscapeKeyDown={visualize == true ? false : true}
            >
                <Box sx={style}>
                    <div ref={contentRef} id="content-pdf" style={{ cursor: 'pointer' }}>
                        <div className="page">
                            <div className="page-content capa">
                                <div className='mobile-logo'>
                                    <img src={Logo} alt="logo" style={isMobile ? { width: '100px' } : { width: '175px' }} />
                                </div>
                                <div className='firstPageTitle mobile-pdf-title'>
                                    <h1>{documento === "PGR" ? "PROGRAMA DE GERENCIAMENTO DE RISCOS" : "PROGRAMA DE CONTROLE MÉDICO DE SAÚDE OCUPACIONAL"}</h1>
                                </div>
                                <div className="empNome nome-empresa-pdf-mobile">{razaoSocial}</div>
                                <div className="fdtNome">{fdt}</div>
                                <div className='vigencia'>
                                    <p>{documento === "PGR" ? "INÍCIO DA VIGÊNCIA" : "DOCUMENTO BASE"} – {dataInicioVigencia}</p>
                                    <p>{documento === "PGR" ? "VIGÊNCIA ANALISE SIMPLES - 12 MESES" : ""}</p>
                                    <p>{documento === "PGR" ? "ANALISE GLOBAL - 24 MESES" : "REVISÃO ANUAL OBRIGATÓRIA - " + data()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="texto">
                        {documento === "PGR" ? <ConteudoPgr props={props} /> : <ConteudoPcmso props={props} />}
                    </div>
                    {!isMobile && (
                        <>
                            {/*  <Tooltip title="Enviar para assinatura">
                                <Button className='btn-main mt-4' style={{ width: '250px', position: 'fixed', top: '1px', right: '-100px' }} onClick={() => setConfirmModal(true)}>
                                    <CreateIcon style={{ marginRight: '10px' }} />
                                    Enviar para assinatura!
                                </Button>
                            </Tooltip> */}
                            {/* <Tooltip title="Download" >
                                <Button className='btn-main mt-4' style={{ width: '250px', position: 'fixed', top: 0, right: '-100px' }} onClick={genPDF}>
                                    <DownloadIcon />
                                    Download
                                </Button>
                            </Tooltip> */}
                        </>
                    )}
                </Box>
            </Modal>
            <Modal
                open={showAccessModal}
                onClose={handleCloseAccessModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Upgrade de Plano</h2>
                    <p style={{ textAlign: 'center' }}>O seu plano atual só comporta {quantidade} Funções, para adicionar mais funções faça um upgrade em seu plano</p>
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos?empresa=${props.idEmpresa}&fdt=${props.idFdt}&revisao=${props.idRevisao}`}>
                        Upgrade
                    </Button>
                </Box>
            </Modal>
            <Modal
                open={showModalFuncoes}
                onClose={handleCloseFunctionModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '500px'
                }}>
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>DADOS FALTANTES</h2>
                    <p style={{ textAlign: 'center' }}>As seguintes funções não possuem descrição: </p>
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                        {funcoesSemDescricao.map((func: any, index) => (
                            <li key={index} style={{ textAlign: 'center' }}>
                                {`${func.pgrGhe.nome} - ${func.AteBaseFuncao.nome}`
                                    || 'Nome da função não disponível'}
                            </li>
                        ))}
                    </ul>
                </Box>
            </Modal>
            <Modal
                open={showFirstAccessModal}
                onClose={handleCloseFirstAccessModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Adquira um Plano</h2>
                    <p style={{ textAlign: 'center' }}>Você registrou um número significativo de funções, mas atualmente não possui um plano. Para acessar mais funcionalidades, por favor, considere adquirir um plano adequado às suas necessidades!</p>
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos?empresa=${props.idEmpresa}&fdt=${props.idFdt}&revisao=${props.idRevisao}`}>
                        Adquirir um Plano
                    </Button>
                </Box>
            </Modal>
            <Modal
                open={showPlanModal}
                onClose={handleClosePlanModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    width: '400px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Adquira um novo Plano</h2>
                    <p style={{ textAlign: 'center' }}>O seu plano não inclui o {documento}, para gerar o documento, adquira um plano que atenda suas necessidades ou faça o upgrade!</p>
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos?empresa=${props.idEmpresa}&fdt=${props.idFdt}&revisao=${props.idRevisao}`}>
                        Adquirir um Plano
                    </Button>
                </Box>
            </Modal>
            <Modal
                open={showModalVencido}
                onClose={() => setShowModalVencido(false)}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '500px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Revisão vencida</h2>
                    <p style={{ textAlign: 'center' }}>Seu plano atual está expirado. Por favor, adquira uma nova revisão!</p>
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos?empresa=${props.idEmpresa}&fdt=${props.idFdt}`}>
                        Clique aqui para adquirir uma nova!
                    </Button>
                </Box>
            </Modal>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })} />
            <Modal open={progressModalOpen} sx={{ display: 'grid', placeItems: 'center' }} disableEscapeKeyDown={true}>
                <Box sx={{ width: '400px', p: 3, bgcolor: 'background.paper', borderRadius: '5px' }}>
                    <Typography sx={{ textAlign: 'center', paddingBottom: '10px' }}>Aguarde, gerando documento.</Typography>
                    <Typography sx={{ textAlign: 'center' }}>{progressValue}%</Typography>
                </Box>
            </Modal>
            <Modal open={confirmModal} sx={{ display: 'grid', placeItems: 'center' }}>
                <Box sx={{ display: 'flex', width: '500px', p: 3, bgcolor: 'background.paper', borderRadius: '5px', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <h5 style={{ textAlign: 'center' }}><b>Tem certeza que deseja enviar para assinatura?</b></h5>
                    <b style={{ fontSize: '15px' }}>Atenção: </b>
                    <p style={{ fontSize: '14px', textAlign: 'center' }}>
                        Você irá enviar o <b>PGR</b> e <b>PCMSO</b> simultaneamente. <b>Esta ação é irreversível.</b>
                    </p>
                    <Box sx={{ flexDirection: 'row', marginTop: '20px' }}>
                        <Button variant="success" style={{ marginRight: '5px' }} onClick={handleSearchFunctionAndGeneratePDF}>
                            Sim
                        </Button>
                        <Button variant="danger" onClick={() => { setConfirmModal(false); setVisualize(true); }}>
                            Não
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}
